import './index.scss'
import ApplicationController from '@app/javascript/controllers/application_controller'

export class Controller extends ApplicationController {
  doConnect() {
    this.resolveCssClasses()
    this.openAncestorNavsIfSelected()
  }

  resolveCssClasses() {
    const parentIdentifier = this.identifier.replace('--item', '')

    this.cssClasses = {
      item: `c-${this.identifier}-item`,
      itemSelected: `c-${this.identifier}-item--selected`,
      parentNav: `c-${parentIdentifier}-container`,
      rootNav: `c-${parentIdentifier}-root`,
      nestedNav: `c-${this.identifier}-nested-nav`
    }
  }

  openAncestorNavsIfSelected() {
    if (!this.isSelected) return

    let ancestorNav = this.element.closest(`.${this.cssClasses.nestedNav}`)

    while (ancestorNav) {
      ancestorNav.classList.remove('hidden')
      ancestorNav = ancestorNav.previousElementSibling.closest(`.${this.cssClasses.nestedNav}`)
    }
  }

  itemClicked() {
    this.closeSiblingsNestedNavs()
    this.openNestedNavForThisItem()

    this.unselectAll()
    this.selectThisItem()
  }

  closeSiblingsNestedNavs() {
    const parentNav = this.element.closest(`.${this.cssClasses.parentNav}`)

    parentNav.querySelectorAll(`.${this.cssClasses.nestedNav}`).forEach(elem => {
      elem.classList.add('hidden')
    })
  }

  openNestedNavForThisItem() {
    const nestedNav = this.element.nextElementSibling
    const isReallyNestedNav = nestedNav.classList.contains(this.cssClasses.nestedNav)

    if (isReallyNestedNav) {
      nestedNav.classList.remove('hidden')
    }
  }

  unselectAll() {
    const rootNav = this.element.closest(`.${this.cssClasses.rootNav}`)

    rootNav.querySelectorAll(`.${this.cssClasses.item}`).forEach(elem => {
      elem.classList.remove(this.cssClasses.itemSelected)
    })
  }

  unselectThisItem() {
    this.element.classList.remove(this.cssClasses.itemSelected)
  }

  selectThisItem() {
    this.element.classList.add(this.cssClasses.itemSelected)
  }

  get isSelected() {
    return this.element.classList.contains(this.cssClasses.itemSelected)
  }
}
